"use client"

import { useState } from "react"
import "./PDFaq.css"

const faqData = [
  {
    question: "Why is our product design process most efficient?",
    answer:
      "Thanks to many years of creating, design thinking, and testing our expert designers developed a unique and distinct method - the Product Design Process (PDP) - that improves UX, enhances conversions, and grows business value.We have perfected our PDP by incorporating the best industry practices and techniques alongside field experience and valuable feedback. The PDP idea focuses on consistently providing exceptional UX/UI Design while keeping costs and benefits balanced on a rapid market launch.It consists of a structured and matured 4-phase methodology (Research, Ideation, Execution, and Technical Assessment) that ensures efficiency, reduces development costs, and plans realistic schedules while keeping in mind the project’s requirements. Our PDP Design has already been adopted by many universities worldwide, and it’s currently part of their academic programs as essential literature in Design courses.",
  },
  {
    question: "What are the 12 steps in design process?",
    answer:
      "The PDP design method contemplates four different phases — research, ideation, execution, and technical assessment - that are then split into 12 steps. These steps are all part of the main framework, providing guidelines on how to design a product.The steps consist of: 1. Briefing 2. User Research 3. Design Benchmark 4. User Journey 5. Decision Matrix 6. Wireframes 7. Mood Board 8. Style Guide 9. Graphic User Interface (GUI) Design 10. Prototype11. High-level Architecture12. Project Plan Learn about each step in more detail here.",
  },
  
]

const ScopingFAQ = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section241">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title">PRODUCT DESIGN PROCESS</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingFAQ;
